import React from 'react';
import Select from 'react-select';

const SMLSelect = (props) => {
  const brandColor = '#66afe9';
  const textColor = '#666';

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '42px',
      width: '100%',
      boxShadow: state.isFocused
        ? '0 0 8px rgba(102, 175, 233, 0.6)'
        : provided.boxShadow,
      borderColor: state.isFocused
        ? brandColor
        : provided.borderColor,
      '&:hover': {
        borderColor: state.isFocused
          ? brandColor
          : provided.borderColor,
      },
      color: textColor
    }),
    singleValue: provided => ({
      ...provided,
      color: textColor
    })
  };

  return (
    <Select {...props} styles={customStyles} />
  );
};

export default SMLSelect;
